const DEFAULT_LOCALE = 'en';

export function getUserLocale(): string {
  return new URLSearchParams(window.location.search).get('locale') || DEFAULT_LOCALE;
}
